import { DefaultService } from '@/services/DefaultService';

export default class SituacaoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }
    
    findAllVendas(column, order, page, limit, situacao = 1, ...params) {
        return this._http.get(encodeURI(`${this._env}/vendas/situacao/findall.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllAgro(column, order, page, limit, situacao, ...params) {
        return this._http.get(encodeURI(`${this._env}/agro/situacao/findall.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllCombo(limit = 50, ...param) {
		return this._http
			.get(encodeURI(`${this._env}/getcombo/situacao.json?limit=${limit}&param=${param}`), this._headers)
			.then((res) => {  return res.body; }, 
            (err) => {
                this.verifyError(err);
                throw new Error('Problems while jobs are loading');
			});
	}

    updateSituacao(obj) {
        return this._http.post(`${this._env}/vendas/situacao/updatesituacao`, obj, this._headers).then(res => {
          return res.body;
        }, err => {
          this.verifyError(err);
          throw err;
        });
    }

    findVendas(id) {
		return this._http.get(`${this._env}/vendas/situacao/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    findAgro(id) {
		return this._http.get(`${this._env}/agro/situacao/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    save(obj) {
        return this._http.post(`${this._env}/vendas/situacao`, obj, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error(err.body.message);
        });
    }

}